// Features/Anchor-Links/mod.ts
document.addEventListener("click", onAnchorClick, {
  capture: true
});
function onAnchorClick(event) {
  let { target } = event;
  if (!target)
    return;
  if (!(target instanceof Element))
    return;
  if (!(target instanceof HTMLAnchorElement)) {
    target = target.closest(`a`);
    if (!target)
      return;
  }
  const { href } = target;
  const there = new URL(href);
  const here = new URL(location.href);
  if (here.host !== there.host)
    return;
  if (here.pathname !== there.pathname)
    return;
  if (there.hash === "")
    return;
  const destination = document.querySelector(there.hash);
  if (!destination)
    return;
  event.preventDefault();
  let scrollTarget = destination;
  const rect = destination.getBoundingClientRect();
  if (rect.height === 0) {
    scrollTarget = destination.nextElementSibling || destination.closest("section, .shopify-section") || destination;
  }
  location.hash = there.hash;
  scrollTarget.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
}
export {
  onAnchorClick
};
